/**
 * A codes domain — a domain staff bought for EyeMed codes and added on the
 * staff console's Portal Codes list (`codesDomains/{domain}`). Shared so the
 * console's add form and the callable refuse the same values.
 */

/** One DNS label: letters, digits and hyphens, not at either end. */
const LABEL = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

/**
 * A lowercase DNS name of two or more labels, whose last label (the
 * top-level domain) starts with a letter, so an IP address is not a domain.
 * Callers lowercase and trim what staff typed before asking.
 */
export function isCodesDomainName(value: unknown): value is string {
  if (typeof value !== "string" || value.length === 0 || value.length > 253) return false;
  const labels = value.split(".");
  if (labels.length < 2 || !labels.every((label) => LABEL.test(label))) return false;
  return /^[a-z]/.test(labels[labels.length - 1]);
}
